import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const EmptyHeart = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="m11.53 4.63.43.47.47-.46a5.68 5.68 0 0 1 4.9-1.56A5.58 5.58 0 0 1 22 8.58v.23c0 1.62-.67 3.17-1.86 4.28l-7.06 6.59a1.59 1.59 0 0 1-2.16 0l-7.06-6.6A5.85 5.85 0 0 1 2 8.82v-.23a5.58 5.58 0 0 1 9.53-3.95Zm.43 3.13-1.75-1.83a3.79 3.79 0 0 0-3.24-1 3.7 3.7 0 0 0-3.1 3.65v.23c0 1.1.46 2.16 1.27 2.9L12 18.13l6.86-6.4c.8-.75 1.27-1.8 1.27-2.91v-.23a3.71 3.71 0 0 0-3.1-3.65 3.79 3.79 0 0 0-3.24 1l-1.83 1.83Z"
    />
  </svg>
));
